import { Directive, Input, OnInit } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[mm-entity-form]'
})
export class MmEntityFormDirective implements OnInit {

  constructor(private formGroupDirective: FormGroupDirective) {

  }
  entityId$ = new BehaviorSubject<any>(undefined);

  ngOnInit(): void {
    var form = this.formGroupDirective.form;

    
    this.entityId$.pipe(
      filter(_ => _ != undefined)
    ).subscribe();
  }


  @Input()
  mmType: string;

  @Input()
  set entityId(_: string) {
    this.entityId$.next(_);
  }

}
